














import { Component, Prop, Vue } from 'vue-property-decorator';
import { Card } from '../../blocks';
import { Warning } from '@/pages/profile/components';
import { Notifications } from '@/services';
import { INotificationsUnread } from './types';

@Component({
  components: {
    Card,
    Warning,
  },
})
export default class NotificationsUnread
  extends Vue
  implements INotificationsUnread {
  @Prop({ type: Array, default: () => [] })
  readonly notifications!: Array<Notifications>;

  get unread() {
    return this.notifications.filter(({ isRead }) => isRead === 'N');
  }

  postData(id: string) {
    if (id) this.$emit('postData', id);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/notification/views/unread/NotificationsUnread.vue